import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { Section } from '../../../editor-container/editor-model';

@Directive({
  selector: '[kwSectionAttributes]'
})
export class SectionAttributesDirective implements AfterViewInit {
  @Input() section:Section;

  constructor(private el: ElementRef,private renderer: Renderer2) { }
  
  ngAfterViewInit(): void {
    if(this.section.sectionData){
      //console.log(this.section.sectionData)
      const host = <HTMLElement>this.el.nativeElement;
      if(this.section.sectionData.numberOfElements){
        this.renderer.setAttribute(host,"number-of-elements",<any>this.section.sectionData.numberOfElements);
        //console.log(host);
      }
      if(this.section.sectionId){
        this.renderer.setAttribute(host,"id",this.section.rendererType+"-"+this.section.sectionId);
      }
    }
    
  }



}
